import {
  SET_KEYWORDS,
  SET_POSITIONS,
  SET_POSITIONS_LOADING,
  SET_HINTS,
  SET_HINTS_LOADING,
} from '../actions/types';

const initialState = {
  keywords: [],
  positions: {},
  loading: false,

  hints: [],
  hints_loading: false,
};

export default function positions(state = initialState, action) {
  switch (action.type) {
    case SET_KEYWORDS:
      return { ...state, keywords: action.payload };

    case SET_POSITIONS:
      return { ...state, positions: action.payload };

    case SET_POSITIONS_LOADING:
      return { ...state, loading: action.payload };

    case SET_HINTS:
      return { ...state, hints: action.payload };

    case SET_HINTS_LOADING:
      return { ...state, hints_loading: action.payload };

    default:
      return state;
  }
}
